<ng-container
  *ngTemplateOutlet="
    content;
    context: {
      currentTask: current$ | async,
      outOfBounds: outOfBounds$ | async,
      taskClosed: taskClosed$ | async,
      taskList: taskList$ | async
    }
  "></ng-container>
<ng-template
  #content
  let-currentTask="currentTask"
  let-outOfBounds="outOfBounds"
  let-taskClosed="taskClosed"
  let-taskList="taskList">
  <mat-toolbar class="toolbar-container">
    <ng-container
      *ngIf="!outOfBounds && (enabled$ | async)"
      class="toolbar-content-container margin-top">
      <mat-toolbar-row>
        <div class="actions-container">
          <div class="tasks-container">
            <q9-icon-button
              #navigationPrev
              [icon]="'arrow_left-icon'"
              [disabled]="!hasPrev"
              [matTooltip]="'TOOLBAR.AUTHORISATION_PREVIOUS_TASK' | translate"
              matTooltipPosition="below"
              (click)="navigationPrev.disabled ? null : navPrev()"></q9-icon-button>
            <button
              *ngIf="!taskClosed"
              class="authorisation-nav-menu-btn"
              [matMenuTriggerFor]="authorisationItems"
              [disabled]="outOfBounds"
              [matTooltip]="'TOOLBAR.AUTHORISATION_TASK_LIST' | translate"
              matTooltipPosition="below">
              <div class="authorisation-nav-label tasks-section">
                <div>
                  {{ 'TOOLBAR.TRAINING_TASK_LABEL' | translate }}
                  {{ currentPosition$ | async }}/{{ taskList?.length }}
                </div>
                <div class="mat-select-arrow-wrapper">
                  <div class="mat-select-arrow"></div>
                </div>
              </div>
            </button>
            <mat-menu #authorisationItems="matMenu" class="q9-menu authorisation-nav-menu">
              <div *ngFor="let task of taskList">
                <button
                  class="authorisation-nav-menu-item"
                  mat-menu-item
                  [ngClass]="{'current-task': currentTask?.diagram === task.diagram}"
                  (click)="processNavigation(task?.diagram)">
                  <div class="menu-item-checkbox">
                    <mat-checkbox
                      class="q9-checkbox"
                      color="primary"
                      [disableRipple]="true"
                      [disabled]="true"
                      [checked]="task.status === 'readyToApprove'"></mat-checkbox>
                  </div>
                  <div class="authorisation-nav-menu-item-label">
                    <div class="item-main-label">
                      <span>{{ task.title | htmlEncoder: true }}</span>
                    </div>
                    <div class="item-secondary-label">
                      <span *ngIf="task.connection">
                        {{ 'TOOLBAR.TRAINING_MENU_LEVEL_LABEL' | translate }}
                        {{ task.connection.levelNumber }}
                        {{ task.connection.map.name | htmlEncoder: true }}
                      </span>
                    </div>
                  </div>
                </button>
                <mat-divider></mat-divider>
              </div>
            </mat-menu>
            <q9-icon-button
              #navigationNext
              [icon]="'arrow_right-icon'"
              [disabled]="!hasNext || outOfBounds"
              [matTooltip]="'TOOLBAR.AUTHORISATION_NEXT_TASK' | translate"
              matTooltipPosition="below"
              (click)="navigationNext.disabled ? null : navNext()"></q9-icon-button>
          </div>
          <q9-icon-button
            [icon]="'information-icon'"
            [matMenuTriggerFor]="authorisationInfo"
            [disabled]="outOfBounds"
            [matTooltip]="'TOOLBAR.CLICK_FOR_INFO_BTN' | translate"
            matTooltipPosition="below"
            (click)="getTaskListHistory()"></q9-icon-button>
          <mat-menu #authorisationInfo="matMenu" class="authorisation-nav-info-menu">
            <app-authorisation-popup
              [showCurrentTask]="false"
              [config]="currentTask"
              [userHistory]="userHistory"></app-authorisation-popup>
          </mat-menu>
          <q9-icon-button
            [icon]="'close-icon'"
            [matTooltip]="'TOOLBAR.AUTHORISATION_CLOSE_TOOLTIP' | translate"
            matTooltipPosition="below"
            (click)="exitAuthorisation()"></q9-icon-button>
        </div>
      </mat-toolbar-row>
      <mat-divider></mat-divider>
      <mat-toolbar-row>
        <div class="btn-container">
          <q9-secondary-button
            #confirmButton
            q9Track="AUTHORIZATION.AUTHORIZE"
            [disabled]="preventClicks || outOfBounds || taskClosed"
            [matTooltip]="'TOOLBAR.AUTHORISATION_SIGN_OFF_TOOLTIP' | translate"
            [matTooltipDisabled]="outOfBounds"
            matTooltipPosition="below"
            (click)="confirmButton.disabled ? null : signOffTask()">
            {{ 'VERSIONING.AUTHORISE' | translate }}
          </q9-secondary-button>
          <q9-secondary-button
            #rejectButton
            *ngIf="!taskClosed"
            class="warn"
            q9Track="AUTHORIZATION.REJECT"
            [disabled]="preventClicks || outOfBounds || isTaskInInvalidStatus(currentTask)"
            [color]="'warn'"
            [matTooltip]="'TOOLBAR.AUTHORISATION_REJECT_TOOLTIP' | translate"
            [matTooltipDisabled]="outOfBounds"
            matTooltipPosition="below"
            (click)="rejectButton.disabled ? null : rejectTask()">
            {{ 'VERSIONING.REJECT' | translate }}
          </q9-secondary-button>
          <mat-slide-toggle
            #acceptInputElement
            color="primary"
            q9Track="AUTHORIZATION.ACCEPT"
            [disabled]="preventClicks || outOfBounds || taskClosed"
            [checked]="currentTask?.status === AUTHORISATION_TASK_STATUSES.READY_TO_APPROVE"
            [matTooltip]="'TOOLBAR.AUTHORISATION_ACCEPT_TOOLTIP' | translate"
            [matTooltipDisabled]="outOfBounds"
            matTooltipPosition="below"
            (change)="acceptTask($event.checked)">
            {{ 'TOOLBAR.AUTHORISATION_TASK_LATER' | translate }}
          </mat-slide-toggle>
        </div>
      </mat-toolbar-row>
    </ng-container>
    <ng-container *ngIf="outOfBounds" class="toolbar-content-container">
      <q9-primary-button
        [matTooltip]="'TOOLBAR.AUTHORISATION_TASK_BACK_TOOLTIP' | translate"
        matTooltipPosition="below"
        (click)="navBackToLastAuthorisationItem()">
        {{ 'TOOLBAR.AUTHORISATION_TASK_BACK' | translate }}
      </q9-primary-button>
    </ng-container>
  </mat-toolbar>
</ng-template>
